import { gameId, topNumber } from '../../../constants/activity-constants'
import GameServices from '../../../services/game-service'
import userSessionStorage from '../../../utils/userSessionStorage'

const session = new userSessionStorage()
const userInfo = session.getUserInfo()
const Store = {
  userdata: { point: 0, position: 0 },
  toplist: [],
}
var currentRequest = null
export function requestTopInfo() {
  if (currentRequest) {
    return currentRequest
  }
  let tokenId = session.getToken()?.idToken
  const config = {
    headers: tokenId
      ? {
          Authorization: tokenId,
        }
      : undefined,
  }
  currentRequest = GameServices.getTopPagination(
    gameId,
    topNumber,
    0,
    config
  ).then(res => {
    if (res.status === 200) {
      Store.userdata = res.data
      Store.toplist = res.data.topGame
    }
    return Store
  })
  return currentRequest
}

export function getUserInfo() {
  return userInfo
}

export function getUserData() {
  return Store.userdata
}

export function getTopList() {
  return Store.toplist
}
